import { ChildrenProp } from 'types';

import styles from './SearchResultsEmptyLabel.module.scss';

const SearchResultsEmptyLabel = ({ children }: ChildrenProp) => {
  return <p className={styles.searchResultsEmptyLabel}>{children}</p>;
};

export default SearchResultsEmptyLabel;
